// extracted by mini-css-extract-plugin
export default {"empty":"jUseKojZiXe_SDuRFLVX"};